'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import ToggleVideoFeatures from 'FileManagerCore/components/modals/ToggleVideoFeatures';
import { getIsVideo2Enabled } from 'FileManagerCore/selectors/Video2OptInStatus';
import { getHasFileManagerWriteScope } from 'FileManagerCore/selectors/Auth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getI18nKey(suffix) {
  return `FileManagerDashboard.emptyDashboard.${suffix}`;
}
class EmptyDashboard extends Component {
  renderHeaderMessage() {
    const {
      archived,
      hasWriteScope
    } = this.props;
    if (archived) {
      return /*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getI18nKey('archived')
        })
      });
    }
    if (hasWriteScope) {
      return /*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getI18nKey('message')
        })
      });
    }
    return /*#__PURE__*/_jsx("h4", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: getI18nKey('viewOnlyMessage')
      })
    });
  }
  renderHintMessage() {
    const {
      hasWriteScope
    } = this.props;
    if (hasWriteScope) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: getI18nKey('uploadHint')
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getI18nKey('viewOnlyHint.part1')
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getI18nKey('viewOnlyHint.part2')
        })
      })]
    });
  }
  renderIllustration() {
    return /*#__PURE__*/_jsx(UIIllustration, {
      width: 150,
      name: "import-file",
      className: "m-y-8"
    });
  }
  renderVideo2OptIn() {
    const {
      isVideo2Enabled
    } = this.props;
    if (isVideo2Enabled) {
      return null;
    }
    return /*#__PURE__*/_jsx("p", {
      className: "m-top-4",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: getI18nKey('video.message'),
        options: {
          turnOn: /*#__PURE__*/_jsx(ToggleVideoFeatures, {
            forEmptyState: true
          })
        }
      })
    });
  }
  renderMessageParagraph() {
    return /*#__PURE__*/_jsxs("div", {
      className: "m-bottom-4",
      children: [this.renderHintMessage(), this.renderVideo2OptIn()]
    });
  }
  renderArchivedMessage() {
    return /*#__PURE__*/_jsxs("div", {
      className: "empty-dashboard display-flex m-all-auto flex-column align-center",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "DASHBOARD_EMPTY"
      }), this.renderIllustration(), this.renderHeaderMessage()]
    });
  }
  renderActiveMessage() {
    return /*#__PURE__*/_jsxs("div", {
      className: "empty-dashboard display-flex m-all-auto",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "m-all-10",
        children: [/*#__PURE__*/_jsx(NavMarker, {
          name: "DASHBOARD_EMPTY"
        }), this.renderHeaderMessage(), this.renderMessageParagraph()]
      }), this.renderIllustration()]
    });
  }
  render() {
    const {
      archived
    } = this.props;
    return archived ? this.renderArchivedMessage() : this.renderActiveMessage();
  }
}
EmptyDashboard.propTypes = {
  isVideo2Enabled: PropTypes.bool.isRequired,
  archived: PropTypes.bool,
  hasVideoIntegrationScope: PropTypes.bool.isRequired,
  hasWriteScope: PropTypes.bool.isRequired
};
EmptyDashboard.defaultProps = {
  archived: false
};
const mapStateToProps = state => ({
  hasWriteScope: getHasFileManagerWriteScope(state),
  isVideo2Enabled: getIsVideo2Enabled(state)
});
export default connect(mapStateToProps)(EmptyDashboard);